<template>
    <div class="productBarContainer">
        <transition name="fade">
            <div v-if="loaded">
                <div class="productCat" v-for="(item, index) in items" v-bind:key="index">
                    <p class="catHeadline" v-if="!ingredientsSection">{{item.name}} </p>
                    <div class="productContainer" v-for="(product, index) in item.globalProducts" :key="index">
                        <div v-if="windowUrl.indexOf(product.productPageLink) == -1">
                            <div v-if="showImage" class="productImg">
                                <a :href="basedir+'/'+product.productPageLink"><img :alt="product.name" v-lazy="product.imageUrl+'?w=57'">
                                </a>
                            </div>
                            <div :class="['productDetails', showImage ? 'showImage' : '']">
                                <a class="headline" :href="basedir+'/'+product.productPageLink" v-html="item.name.length > 50 ? product.name.slice(0, 50)+'...' : product.name"></a>
                                <span class="excerpt" v-html="product.description.trim().length > 100 && showImage ? product.description.slice(0, 100).trim()+'...' : product.description.trim()"></span>
                                <a class="readMore" :href="basedir+'/'+product.productPageLink"><webmessage searchKey="wsm_ReadMore" :text="$root.language.wsm_ReadMore"></webmessage>  <font-awesome-icon :icon="['fas', 'angle-right']" /></a>
                            </div>
                        </div>
                    </div>
                    <hr v-if="!ingredientsSection">
                </div>
            </div>
        </transition>
        <div v-if="!loaded">
            <div class="loadContainer" v-for="n in resultNo" v-bind:key="n">
                <br>
                <vue-content-loading class="loaderHeadline" v-if="n == 1 || n == 3" :rtl="true" :width="20000" primary="#caedb9" secondary="#faf8f4" :height="1500" :speed="1">
                    <rect x="75" y="13" rx="4" ry="4" width="100%" height="100%" />
                </vue-content-loading>
                <vue-content-loading :rtl="true" :width="20000" primary="#f5f2eb" secondary="#faf8f4" :height="2500" :speed="1">
                    <rect x="75" y="13" rx="4" ry="4" width="100%" height="100%" />
                </vue-content-loading>
                <vue-content-loading class="textLoader" :rtl="true" :width="300" :height="20" :speed="1" primary="#f5f2eb" secondary="#faf8f4">
                    <rect x="75" y="13" rx="4" ry="4" width="100%" height="100%" />
                </vue-content-loading>
                <vue-content-loading class="textLoader" :rtl="true" :width="250" :height="20" :speed="1" primary="#f5f2eb" secondary="#faf8f4">
                    <rect x="75" y="13" rx="4" ry="4" width="100%" height="100%" />
                </vue-content-loading>
                <vue-content-loading style="margin-top:-10px;margin-bottom:-8px;" :rtl="true" :width="175" :height="29" :speed="1" primary="#f5f2eb" secondary="#faf8f4">
                    <rect x="75" y="13" rx="4" ry="4" width="100%" height="100%" />
                </vue-content-loading>
                <br><br>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["items", "loaded", "showImage", "resultNo", "productid"],
        computed: {
            basedir: function() {
                return basedir;
            },
            cachedItem: function() {
                return this.items;
            },
            windowUrl: function() {
                return window.location.href
            },
            ingredientsSection: function() {                         
                if(this.$root.isIngredients){
                    return true
                }else{
                    return false;
                }       
            }
        },
    }
</script>

<style lang="scss">
    .relationItem {
        .quantityString p {
            display: inline-block !important;
            color: black !important;
            font-size: 0.7em !important;
        }
        .excerpt p {
            color: #696969;
            font-size: 0.8em;
            margin: 0;
            margin-bottom: 5px;
        }
        .excerpt p em,
        .excerpt p i {
            font-size: 0.9em;
        }
    }
</style>

<style lang="scss" scoped>
    svg.textLoader {
        margin-top: -7px;
        display: block;
    }
    .productContainer {
        margin-bottom: 26px;
    }
    .productBarContainer .productCat:nth-child(1) .catHeadline {
        margin-top: 0;
    }
    .catHeadline {
        color: #7caf63;
        font-weight: bold;
        margin-top: 20px;
        text-decoration: underline;
    }
    img {
        width: auto;
        margin-bottom: 5px;
        border-radius: 5px;
        max-height:50px;
    }
    .quantityString {
        display: inline-block;
        color: #190e0e;
        font-size: 1em;
        margin-bottom: 0;
    }
    .quantityString p {
        display: inline-block !important;
        color: black !important;
        font-size: 0.7em !important;
    }
    .productImg {
        width: 20%;
        display: inline-block;
        margin-right: 2%;
    }
    .productDetails {
        display: inline-block;
        width: 100%;
        vertical-align: top;
    }
    .showImage {
        width: 75%;
    }
    .headline {
        color: #004570;
        font-weight: bold;
        text-transform: uppercase;
        display: inline-block;
        font-size: 0.8em;
        display: inline;
        margin-right: 9px;
    }
    .readMore {
        margin-bottom: 0;
        display: inline-block;
        .fa-angle-right {
            vertical-align: middle;
            margin-left: 2px;
            margin-top: -1px;
            transition: all 0.2s ease-in-out;
        }
        &:hover {
            .fa-angle-right {
                margin-left: 5px;
            }
        }
    }
    .readMoreLoader {
        margin-top: -25px;
        margin-bottom: -15px;
    }
    .typeBadge {
        margin-bottom: 0;
        display: block;
        font-style: italic;
        position: relative;
        color: #696969;
    }
</style>